import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { isSameOrigin } from '../../../utilities/backend-helpers/index.js';
import '../../../atoms/buttons/enums.js';
import { getLinkURL, isLink, isRTL } from '../../../utilities/dom-helpers/index.js';
import { CategoryTileSmall } from '../../category-tile-small/index.js';
import { MainCategoriesItem } from '../../main-categories/main-categories-item.js';
import css_248z from './external-link.scss.js';

class ExternalLink extends s {
    constructor() {
        super(...arguments);
        this.modal = null;
        this.hostList = [];
        this.okBtn = null;
        this.cancelBtn = null;
        this.url = '';
        this.popupData = null;
        this.rtl = false;
    }
    findButtonsInFooter() {
        var _a, _b;
        const footerSlot = (_b = (_a = this.modal) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('slot[name="footer"]');
        const footerElements = (footerSlot === null || footerSlot === void 0 ? void 0 : footerSlot.assignedElements({ flatten: true })) || [];
        const footerButtons = [];
        footerElements.forEach(el => {
            var _a;
            if (((_a = el.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'generic-button-updated') {
                footerButtons.push(el);
            }
            else if (el instanceof HTMLElement) {
                const nestedButtons = el.querySelectorAll('generic-button-updated');
                nestedButtons.forEach(btn => footerButtons.push(btn));
            }
        });
        return footerButtons;
    }
    setPopupData() {
        var _a;
        const externalPopupDiv = document.querySelector('[data-external-popup]');
        const externalPopupData = externalPopupDiv === null || externalPopupDiv === void 0 ? void 0 : externalPopupDiv.getAttribute('data-external-popup');
        const okBtnSlot = this.shadowRoot.querySelector('slot[name=primary-cta]');
        const [firstOkBtn] = (okBtnSlot === null || okBtnSlot === void 0 ? void 0 : okBtnSlot.assignedElements()) || [];
        this.okBtn = firstOkBtn;
        const cancelBtnSlot = this.shadowRoot.querySelector('slot[name=secondary-cta]');
        const [firstCancelBtn] = (cancelBtnSlot === null || cancelBtnSlot === void 0 ? void 0 : cancelBtnSlot.assignedElements()) || [];
        this.cancelBtn = firstCancelBtn;
        if (!this.okBtn || !this.cancelBtn) {
            const footerButtons = this.findButtonsInFooter();
            const [firstFooterBtn, secondFooterBtn] = footerButtons;
            if (firstFooterBtn && !this.okBtn) {
                this.okBtn = firstFooterBtn;
            }
            if (secondFooterBtn && !this.cancelBtn) {
                this.cancelBtn = secondFooterBtn;
            }
            else if (firstFooterBtn && !this.cancelBtn && this.okBtn !== firstFooterBtn) {
                this.cancelBtn = firstFooterBtn;
            }
        }
        this.popupData = (externalPopupData === null || externalPopupData === void 0 ? void 0 : externalPopupData.length) && JSON.parse(externalPopupData);
        this.hostList = (_a = this.popupData) === null || _a === void 0 ? void 0 : _a.hosts;
    }
    isUrlInHostlist(url, hostlist = this.hostList) {
        return hostlist.find(host => {
            if (host.startsWith('http')) {
                try {
                    const hostURL = new URL(host);
                    return hostURL.hostname === url.hostname;
                }
                catch (_a) {
                    return false;
                }
            }
            else {
                return url.hostname.indexOf(host) > -1;
            }
        });
    }
    isUrlInternalSite(urlToCheck) {
        try {
            const baseUrl = new URL(document.baseURI);
            const url = new URL(urlToCheck, document.baseURI);
            if (url.hostname === baseUrl.hostname) {
                return false;
            }
            if (this.isUrlInHostlist(url)) {
                return true;
            }
        }
        catch (_a) {
            return false;
        }
        return false;
    }
    redirectOnOkClick(capture = false) {
        const clickEvent = (e) => {
            e.stopPropagation();
            this.modal.hideModal();
            if (this.url)
                window.open(this.url, '_blank');
        };
        if (this.okBtn) {
            const clonedOkBtn = this.okBtn.cloneNode(true);
            this.okBtn.parentNode.replaceChild(clonedOkBtn, this.okBtn);
            this.okBtn = clonedOkBtn;
            clonedOkBtn.addEventListener('click', e => clickEvent(e), capture);
        }
    }
    static findLinkInComposedPath(composedPath) {
        for (const element of composedPath) {
            if (element instanceof HTMLButtonElement ||
                element instanceof HTMLSelectElement ||
                element instanceof HTMLInputElement) {
                return null;
            }
            if (element instanceof HTMLAnchorElement) {
                return element;
            }
            if (element instanceof HTMLElement && element.shadowRoot) {
                const anchor = element.shadowRoot.querySelector(':scope > a');
                if (anchor) {
                    return anchor;
                }
            }
            if (element === document.documentElement || element instanceof Document) {
                break;
            }
        }
        return null;
    }
    static shouldSkipUrl(url, linkElement) {
        var _a;
        const anchorElement = linkElement instanceof HTMLAnchorElement ? linkElement : null;
        if ((anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.classList.contains('optanon-toggle-display')) ||
            (anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.closest('.optanon-toggle-display'))) {
            return true;
        }
        const rawHref = (_a = anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.getAttribute('href')) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
        if (rawHref === '#' || (rawHref === null || rawHref === void 0 ? void 0 : rawHref.startsWith('#'))) {
            return true;
        }
        try {
            const urlObj = new URL(url, document.baseURI);
            const protocol = urlObj.protocol.toLowerCase();
            const safeProtocols = new Set(['http:', 'https:', 'mailto:', 'tel:']);
            if (!safeProtocols.has(protocol)) {
                return true;
            }
            return (urlObj.pathname === 'void(0)' ||
                urlObj.href.startsWith('mailto:') ||
                urlObj.href.startsWith('tel:'));
        }
        catch (_b) {
            return true;
        }
    }
    static normalizeUrl(url) {
        try {
            const urlObj = new URL(url);
            if (urlObj.pathname === '/' && !urlObj.search && !urlObj.hash) {
                return url.replace(/\/$/, '');
            }
            return url;
        }
        catch (_a) {
            return url;
        }
    }
    static extractUrl(target, webComponentTarget, linkElement, contextToCheck) {
        if (linkElement instanceof HTMLAnchorElement) {
            return ExternalLink.normalizeUrl(linkElement.href);
        }
        let extractedUrl = getLinkURL(target);
        if (isLink(webComponentTarget, contextToCheck)) {
            extractedUrl = getLinkURL(webComponentTarget);
        }
        if ((target === null || target === void 0 ? void 0 : target.parentNode) instanceof CategoryTileSmall ||
            (target === null || target === void 0 ? void 0 : target.parentNode) instanceof MainCategoriesItem) {
            extractedUrl = target === null || target === void 0 ? void 0 : target.parentNode.href;
        }
        return ExternalLink.normalizeUrl(extractedUrl);
    }
    handleClick(e, capture) {
        var _a;
        e.stopPropagation();
        const isInsideCountrySelector = e.composedPath().some((el) => { var _a; return el instanceof HTMLElement && ((_a = el.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'country-selector'; });
        if (isInsideCountrySelector)
            return;
        const isInsideGlobalNav = e.composedPath().some((el) => { var _a; return el instanceof HTMLElement && ((_a = el.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'global-nav'; });
        if (isInsideGlobalNav)
            return;
        const target = e.target;
        const webComponentTarget = e.composedPath()[0];
        const contextToCheck = [CategoryTileSmall, MainCategoriesItem];
        const composedPathHasInteractiveControl = e.composedPath().some(el => el instanceof HTMLButtonElement ||
            el instanceof HTMLSelectElement ||
            el instanceof HTMLInputElement);
        if (composedPathHasInteractiveControl) {
            return;
        }
        const composedPath = e.composedPath();
        const linkElement = ExternalLink.findLinkInComposedPath(composedPath);
        if (!linkElement &&
            !isLink(target, contextToCheck) &&
            !isLink(webComponentTarget, contextToCheck)) {
            return;
        }
        const extractedUrl = ExternalLink.extractUrl(target, webComponentTarget, linkElement, contextToCheck);
        if (ExternalLink.shouldSkipUrl(extractedUrl, linkElement)) {
            return;
        }
        this.url = extractedUrl;
        if (this.url && isSameOrigin(this.url)) {
            return;
        }
        if (this.isUrlInternalSite(this.url)) {
            if (this.url) {
                window.location.href = this.url;
            }
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.redirectOnOkClick(capture);
        (_a = this.modal) === null || _a === void 0 ? void 0 : _a.showModal();
        window.CVTModalTargetElement = webComponentTarget;
    }
    addOnClickEvents(node = document, capture = false) {
        node.addEventListener('click', (e) => this.handleClick(e, capture), capture);
    }
    hideModalOnOkClick() {
        var _a;
        (_a = this.cancelBtn) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            this.modal.hideModal();
        });
    }
    applyTabletStylingsToModal() {
        var _a;
        (_a = this.modal
            .shadowRoot.querySelector('.cvtm')) === null || _a === void 0 ? void 0 : _a.classList.add('limited-width');
    }
    firstUpdated() {
        this.modal = document.querySelector('cvt-modal-updated[popupid="external-link"]');
        if (!this.modal)
            return;
        this.applyTabletStylingsToModal();
        this.setPopupData();
        this.hideModalOnOkClick();
        this.addOnClickEvents();
    }
    render() {
        return $ `<div slot="content" class="modal-content ${this.rtl || isRTL() ? 'rtl' : ''}"><slot name="heading"></slot><slot name="main-text"></slot><div class="cta-container"><slot name="primary-cta"></slot><slot name="secondary-cta"></slot></div></div>`;
    }
}
ExternalLink.styles = css_248z;
__decorate([
    t()
], ExternalLink.prototype, "modal", void 0);
__decorate([
    t()
], ExternalLink.prototype, "hostList", void 0);
__decorate([
    t()
], ExternalLink.prototype, "okBtn", void 0);
__decorate([
    t()
], ExternalLink.prototype, "cancelBtn", void 0);
__decorate([
    t()
], ExternalLink.prototype, "url", void 0);
__decorate([
    t()
], ExternalLink.prototype, "popupData", void 0);
__decorate([
    e({ type: Boolean })
], ExternalLink.prototype, "rtl", void 0);
customElements.define('external-link', ExternalLink);

export { ExternalLink };
